/**
 * Stack Component
 *
 * Abstraction layer over MUI Stack.
 * Useful for flexbox layouts with consistent spacing.
 */

import { Stack as MuiStack, StackProps } from '@mui/material';
import React from 'react';

const Stack = React.forwardRef<HTMLDivElement, StackProps>((props, ref) => {
  return <MuiStack ref={ref} {...props} />;
});

Stack.displayName = 'Stack';

export default Stack;
